module.exports = __webpack_public_path__ + "static/media/Discourse on Human Virtues.516b2f51.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/PHIL/Discourse on Human Virtues.pdf
// module id = 154
// module chunks = 0